import AdminTop from './AdminTop';

export default AdminTop;
